module.exports = __webpack_public_path__ + "img/3steps-skills-path.ec9aa913.png";